document.addEventListener('DOMContentLoaded', function () {

  const builder = document.querySelector('.kit-builder');

  if (!builder) {
    return;
  }


  // ==================================================
  // CONFIGURATION
  // ==================================================

  // Kit size value → [label, bass drums, rack / floor toms]. The piece
  // count is the bass drum(s) and toms (the snare is added separately),
  // e.g. a 3 piece is a bass drum, a rack tom and a floor tom.
  const KIT_SIZES = {
    'single-drum': ['Single Drum', 0, 1],
    '3-piece':        ['3 Piece', 1, 2],
    '4-piece':        ['4 Piece', 1, 3],
    '5-piece':        ['5 Piece', 1, 4],
    '5-piece-2-bass': ['5 Piece – 2 Bass Drums', 2, 3],
    '6-piece-1-bass': ['6 Piece – 1 Bass Drum', 1, 5],
    '6-piece-2-bass': ['6 Piece – 2 Bass Drums', 2, 4],
    '7-piece-2-bass': ['7 Piece – 2 Bass Drums', 2, 5]
  };

  // Finish image field for each kit size: [field, rack toms ("up"), floor toms ("down")].
  // The first listed is the default until toms are chosen; see getKitImage().
  const KIT_IMAGES = {
      'single-drum': [
    ['single_rack_tom_image', 1, 0],
    ['single_floor_tom_image', 0, 1]
  ],
    '3-piece':        [['3_piece_image', 1, 1]],
    '4-piece':        [['4_piece_1_up_2_down', 1, 2], ['4_piece_2_up_1_down', 2, 1]],
    '5-piece':        [['5_piece_3_up_1_down', 3, 1], ['5_piece_2_up_2_down', 2, 2]],
    '5-piece-2-bass': [['5_piece_double_bass_2_up_1_down', 2, 1]],
    '6-piece-1-bass': [['6_piece_3_up_2_down', 3, 2]],
    '6-piece-2-bass': [['6_piece_double_bass_2_up_2_down', 2, 2]],
    '7-piece-2-bass': [['7_piece_double_bass_3_up_2_down', 3, 2]]
  };

  const SNARE_COMPONENT = { type: 'snare', label: 'Snare Drum' };

  const MAPLE_FINISH_SURCHARGE = 173.40;

  // Every displayed price is the stored price less 20%, then × 1.2, then × 1.3
  // (e.g. £97.10 → £121.18). Each item is calculated, then the total is summed.
  const PRICE_MULTIPLIERS = [0.8, 1.2, 1.3];
  const SURCHARGED_FINISH_TYPES = ['sprayed', 'exotic veneer'];

  const MAIN_OPTION = '[data-options] [data-value]:not([data-accessory-option])';

  const priceFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });


  // ==================================================
  // ELEMENTS
  // ==================================================

  const $ = (selector, root = builder) => root.querySelector(selector);
  const $$ = (selector, root = builder) => Array.from(root.querySelectorAll(selector));

  const dynamicSteps = $('[data-dynamic-steps]');
  const summary = $('[data-kit-summary]');
  const kitSizeStep = $('[data-step="0"]');
  const shellStep = $('[data-step="1"]');
  const finishStep = $('[data-step="2"]');
  const finishOptions = $('[data-finish-options]');

  if (!dynamicSteps || !summary || !kitSizeStep || !shellStep || !finishStep || !finishOptions) {
    return;
  }

  const restartButton = $('[data-restart-builder]');
  const progress = $('[data-progress]');
  const requestButton = $('[data-open-request-form]');
  const requestModal = $('[data-request-form-wrapper]');
  const requestDialog = requestModal && $('.kit-builder__request-dialog', requestModal);
  const restartModal = $('[data-restart-modal]');

  const snareModal = $('[data-snare-modal]');
  const thanksModal = $('[data-thanks-modal]');
  const requestForm = requestModal && $('form', requestModal);

  const MODALS = [requestModal, restartModal, snareModal, thanksModal].filter(Boolean);
  const snareActions = $('[data-snare-actions]');

  const yourKit = $('.kit-builder__your-kit');
  const builderSteps = $('[data-builder-steps]');
  const miniSummary = $('[data-mini-summary]');

  const shellDependentSource = $('[data-shell-dependent-data]');
  const shellDependentRecords = parseJSON(shellDependentSource, {});


  // ==================================================
  // STATE
  // ==================================================

  let currentComponents = null;
  let hasSnare = false;
  let summarySelections = [];
  let lastFocusedElement = null;


  // ==================================================
  // UTILITIES
  // ==================================================

  function parseJSON(element, fallback) {

    if (!element) {
      return fallback;
    }

    try {
      const raw = element.textContent.trim();
      return raw ? JSON.parse(raw) : fallback;
    } catch (error) {
      console.error('Kit builder: unable to parse JSON data', error);
      return fallback;
    }

  }


  function escapeHTML(value) {

    return String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[character]);

  }


  function formatPrice(value) {
    return priceFormatter.format(Number(value) || 0);
  }


  function formatCost(value) {
    return value > 0 ? formatPrice(value) : 'Base Price';
  }


  // Strips currency symbols. Whole numbers of 1000+ are treated as pence.
  function parsePrice(raw) {

    const price = parseFloat(String(raw || '').replace(/[£$€,]/g, ''));

    if (!Number.isFinite(price)) {
      return 0;
    }

    return Number.isInteger(price) && Math.abs(price) >= 1000
      ? price / 100
      : price;

  }


  function materialOf(value) {

    const text = String(value || '').toLowerCase();

    if (text.includes('maple')) {
      return 'maple';
    }

    if (text.includes('oak')) {
      return 'oak';
    }

    return '';

  }


  function matchesMaterial(shellText, material) {
    return Boolean(material) && materialOf(shellText) === material;
  }


  // ==================================================
  // OPTIONS & SELECTION
  // ==================================================

  function isSelected(option) {
    return option.classList.contains('is-selected');
  }


  function markSelected(option, selected) {
    option.classList.toggle('is-selected', selected);
    option.setAttribute('aria-pressed', String(selected));
    option.dataset.selected = String(selected);
  }


  // Options that share a [data-options] container are mutually exclusive.
  function getGroup(option) {
    return $$('[data-value]', option.closest('[data-options]'));
  }


  function selectInGroup(option) {
    getGroup(option).forEach((item) => markSelected(item, item === option));
  }


  function findSelected(step, selector) {
    return $$(selector, step).find(isSelected) || null;
  }


  function getSelected(step) {
    return isShellDependentStep(step) ? null : findSelected(step, MAIN_OPTION);
  }


  // type: 'lugs', 'mount', 'bearing_edge', 'tone_control', 'tension_rod', 'hoops', 'spurs', 'throw'
  function getAccessory(step, type) {
    return findSelected(step, `[data-accessory-type="${type}"]`);
  }


  function getAccessoryGroups(step) {

    return $$('[data-accessory-group]', step).map((group) => ({
      type: group.dataset.accessoryGroup,
      label: group.dataset.accessoryLabel || group.dataset.accessoryGroup,
      // Groups with no records in the store aren't required.
      required: Boolean($('[data-accessory-option]', group))
    }));

  }


  // { lugs: 'imperial', mount: 'legs', … } for the step's current choices.
  function getAccessoryValues(step) {

    const values = {};

    getAccessoryGroups(step).forEach(function ({ type }) {
      values[type] = valueOf(getAccessory(step, type));
    });

    return values;

  }


  function restoreAccessories(step, values) {

    Object.keys(values || {}).forEach(function (type) {
      restoreChoice(step, `[data-accessory-type="${type}"]`, values[type]);
    });

  }


  // type: 'badge' | 'interior'
  function getShellDependent(step, type) {
    return findSelected(step, `[data-shell-dependent-type="${type}"]`);
  }


  function valueOf(option) {
    return option ? option.dataset.value : '';
  }


  function getOptionText(option) {

    const name = option.querySelector('.kit-builder__option-name, .kit-builder__image-option-name');

    return name
      ? name.textContent.trim()
      : option.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();

  }


  function getShellMaterial() {

    const shell = getSelected(shellStep);

    if (!shell) {
      return '';
    }

    return (
      materialOf(shell.dataset.shellMaterial) ||
      materialOf(`${shell.dataset.value} ${getOptionText(shell)}`) ||
      'oak'
    );

  }


  // ==================================================
  // PRICING
  // ==================================================

  function getRawCost(option, material) {
    return material === 'maple' ? option.dataset.mapleCost : option.dataset.oakCost;
  }


  function getPrice(option, material = getShellMaterial()) {

    // Badge and interior are always included.
    if (option.hasAttribute('data-shell-dependent-option')) {
      return 0;
    }

    let price = parsePrice(getRawCost(option, material));

    const finishType = (option.dataset.finishType || '').trim().toLowerCase();

    if (
      material === 'maple' &&
      option.classList.contains('kit-builder__finish-option') &&
      SURCHARGED_FINISH_TYPES.includes(finishType)
    ) {
      price += MAPLE_FINISH_SURCHARGE;
    }

    return toDisplayPrice(price);

  }


  // Applies PRICE_MULTIPLIERS, rounded to the penny so the total always
  // matches the sum of the prices shown.
  function toDisplayPrice(price) {
    const value = PRICE_MULTIPLIERS.reduce((total, multiplier) => total * multiplier, price);
    return Math.round(value * 100) / 100;
  }


  // Pass null to remove the price label.
  function setPriceLabel(option, price) {

    const old = option.querySelector('.kit-builder__option-price');

    if (old) {
      old.remove();
    }

    if (price === null) {
      return;
    }

    const label = document.createElement('span');
    label.className = 'kit-builder__option-price';
    label.textContent = `(${formatCost(price)})`;
    option.appendChild(label);

  }


  function setOptionVisible(option, visible) {

    option.hidden = !visible;

    if (!visible && isSelected(option)) {
      markSelected(option, false);
    }

  }


  function renderPrices() {

    const material = getShellMaterial();

    getSteps().forEach(function (step) {

      if (isShellDependentStep(step)) {

        $$('[data-shell-dependent-option]', step).forEach(function (option) {
          const visible = matchesMaterial(option.dataset.shellMaterial, material);
          setOptionVisible(option, visible);
          setPriceLabel(option, visible ? 0 : null);
        });

        updateShellDependentStatus(step);
        return;

      }

      const isComponent = Boolean(step.dataset.componentType);

      $$(MAIN_OPTION, step).forEach(function (option) {

        const price = getPrice(option, material);

        if (isComponent) {
          // Drums without a price for this shell material are not offered.
          const available = parsePrice(getRawCost(option, material)) > 0;
          setOptionVisible(option, available);
          setPriceLabel(option, available ? price : null);
          return;
        }

        option.hidden = false;

        // Finishes always show a price ("Base Price" at £0); kit size and
        // shell only show one when there's a cost.
        const isFinish = option.classList.contains('kit-builder__finish-option');
        setPriceLabel(option, isFinish || price > 0 ? price : null);

      });

      $$('[data-accessory-option]', step).forEach(function (option) {
        setPriceLabel(option, getPrice(option, material));
      });

      filterAccessories(step);

    });

  }


  // ==================================================
  // ACCESSORY FILTERING (toms and snare)
  // ==================================================

  // Groups marked data-filtered (tom lugs / mount, all snare options) only
  // show the records listed in the selected size's data-allowed-<group>.
  // Nothing is shown until a size is chosen; a size without an allowed
  // list allows everything.
  function filterAccessories(step) {

    if (!step.hasAttribute('data-filter-accessories')) {
      return;
    }

    const drum = getSelected(step);

    $$('[data-accessory-group][data-filtered]', step).forEach(function (group) {

      const type = group.dataset.accessoryGroup;
      const noun = group.dataset.accessoryNoun || type;
      const allowedList = drum ? drum.getAttribute(`data-allowed-${type}`) : null;
      const allowed = allowedList === null ? null : allowedList.split(',').filter(Boolean);

      let visibleCount = 0;

      $$(`[data-accessory-type="${type}"]`, group).forEach(function (option) {

        const visible = Boolean(drum) && (allowed === null || allowed.includes(option.dataset.handle));

        setOptionVisible(option, visible);

        if (visible) {
          visibleCount++;
        }

      });

      const empty = $('[data-accessory-empty]', group);

      if (empty) {
        empty.hidden = visibleCount > 0;
        empty.textContent = drum
          ? `No ${noun} are available for this size.`
          : `Select a size to see the available ${noun}.`;
      }

    });

  }


  // ==================================================
  // STEPS
  // ==================================================

  function getSteps() {
    return $$('.kit-builder__step[data-step], [data-dynamic-steps] .kit-builder__step');
  }


  function getDynamicSteps() {
    return $$('.kit-builder__step', dynamicSteps);
  }


  function getDrumSteps() {
    return $$('[data-component-step]', dynamicSteps);
  }


  function getShellDependentStep() {
    return $('[data-shell-dependent-step]', dynamicSteps);
  }


  function isShellDependentStep(step) {
    return step.hasAttribute('data-shell-dependent-step');
  }


  function getComponentLabel(step) {
    const label = $('.kit-builder__component-label', step);
    return label ? label.textContent.trim() : 'Drum';
  }


  function numberSteps() {

    getSteps().forEach(function (step, index) {

      const number = $('.kit-builder__step-number', step);

      if (number) {
        number.textContent = index + 1;
      }

    });

  }


  function isStepComplete(step) {

    if (isShellDependentStep(step)) {
      return Boolean(getShellDependent(step, 'badge') && getShellDependent(step, 'interior'));
    }

    if (step.dataset.componentType) {
      return Boolean(getSelected(step)) && getAccessoryGroups(step).every(
        ({ type, required }) => !required || Boolean(getAccessory(step, type))
      );
    }

    return Boolean(getSelected(step));

  }


  function isConfigurationComplete() {

    const dynamic = getDynamicSteps();

    return (
      [kitSizeStep, shellStep, finishStep].every(getSelected) &&
      dynamic.length > 0 &&
      dynamic.every(isStepComplete)
    );

  }


  function updateStepState(step) {
    step.classList.toggle('is-complete', isStepComplete(step));
  }


  function clearStep(step) {
    $$('[data-value]', step).forEach((option) => markSelected(option, false));
    step.classList.remove('is-complete', 'is-current');
  }


  function showStep(step, scroll = true) {

    if (!step || step.hidden || !step.isConnected) {
      return;
    }

    if (step === finishStep && !getSelected(shellStep)) {
      return;
    }

    getSteps().forEach((other) => other.classList.remove('is-current'));

    step.classList.add('is-current');

    if (scroll) {
      scrollToElement(step);
    }

  }


  // Moves to the first unfinished step after this one (wrapping round
  // to earlier steps). When everything is complete, nothing is current.
  function showNextIncompleteStep(step) {

    const steps = getSteps().filter((item) => !item.hidden);
    const index = steps.indexOf(step);
    const ordered = steps.slice(index + 1).concat(steps.slice(0, index + 1));
    const next = ordered.find((item) => !isStepComplete(item));

    if (next) {
      showStep(next);
    } else {
      steps.forEach((item) => item.classList.remove('is-current'));
    }

  }


  // ==================================================
  // KIT SIZE OPTIONS
  // ==================================================

  function renderKitSizeOptions() {

    const container = $('[data-options]', kitSizeStep);

    if (!container) {
      return;
    }

    container.innerHTML = Object.keys(KIT_SIZES).map((value) => `
      <button type="button" class="kit-builder__option" data-value="${escapeHTML(value)}" aria-pressed="false">
        <span class="kit-builder__option-name">${escapeHTML(KIT_SIZES[value][0])}</span>
      </button>
    `).join('');

  }


  function buildComponents(kitSize) {

    const [, bassCount, tomCount] = KIT_SIZES[kitSize];
    const components = [];

    for (let i = 1; i <= bassCount; i++) {
      components.push({
        type: 'bass_drum',
        label: bassCount > 1 ? `Bass Drum ${i}` : 'Bass Drum'
      });
    }

    for (let i = 1; i <= tomCount; i++) {
      components.push({
        type: 'floor_and_rack',
        label: `Rack / Floor Tom ${i}`
      });
    }

    return components;

  }


  // ==================================================
  // FINISH OPTIONS
  // ==================================================

  function renderFinishOptions() {

    const shell = getSelected(shellStep);
    const data = shell ? parseJSON($('[data-shell-finish-data]', shell), []) : [];
    const finishes = Array.isArray(data) ? data.filter(Boolean) : [];

    finishOptions.hidden = false;

    if (!finishes.length) {
      finishOptions.innerHTML =
        '<div class="kit-builder__finish-empty">No finishes are available for this shell.</div>';
      return;
    }

    const buttons = finishes.map(function (finish, index) {

      const name = finish.name || finish.value || `Finish ${index + 1}`;
      const image = finish.singleDrumImage || finish.image || '';

      return `
        <button
          type="button"
          class="kit-builder__option kit-builder__image-option kit-builder__finish-option"
          data-value="${escapeHTML(finish.value || name)}"
          data-option-name="${escapeHTML(name)}"
          data-finish-type="${escapeHTML(finish.type || '')}"
          data-oak-cost="${escapeHTML(finish.oakCost || 0)}"
          data-maple-cost="${escapeHTML(finish.mapleCost || 0)}"
          data-finish-image="${escapeHTML(finish.image || '')}"
          data-kit-images="${escapeHTML(JSON.stringify(finish.kitImages || {}))}"
          aria-pressed="false"
        >
          ${image ? `<img class="kit-builder__image-option-image" src="${escapeHTML(image)}" alt="${escapeHTML(name)}" loading="lazy">` : ''}
          <span class="kit-builder__image-option-name">${escapeHTML(name)}</span>
        </button>
      `;

    }).join('');

    finishOptions.innerHTML = `<div class="kit-builder__options" data-options>${buttons}</div>`;

  }


  // ==================================================
  // KIT IMAGE
  // ==================================================

  // 'up' (rack tom), 'down' (floor tom) or '' if not chosen.
  // Uses the size's tom_type field ("Rack" / "Floor"), then its name, then
  // its dimensions: floor toms are nearly as deep as they are wide
  // (14x14, 16x16, 18x16); rack toms are shallower (10x7, 12x8, 13x9).
  function getTomPosition(option) {

    if (!option) {
      return '';
    }

    const text = `${option.dataset.tomType || ''} ${getOptionText(option)}`.toLowerCase();

    if (/floor|down/.test(text)) {
      return 'down';
    }

    if (/rack|\bup\b|mounted/.test(text)) {
      return 'up';
    }

    const size = text.match(/(\d+(?:\.\d+)?)\s*["”]?\s*[x×]\s*(\d+(?:\.\d+)?)/);

    if (size) {
      const [, diameter, depth] = size.map(Number);
      return depth >= diameter - 2 ? 'down' : 'up';
    }

    return '';

  }


  function getTomCounts() {

    const counts = { up: 0, down: 0 };

    getDrumSteps().forEach(function (step) {

      const position = step.dataset.componentType === 'floor_and_rack'
        ? getTomPosition(getSelected(step))
        : '';

      if (position) {
        counts[position]++;
      }

    });

    return counts;

  }


  // The selected finish's image for this kit size and tom arrangement.
  // Images are ranked by:
  //   1. how many chosen toms they can't show (e.g. "3 up 1 down" can't
  //      show a second floor tom), so ruled-out arrangements drop back;
  //   2. how far their up / down counts are from the toms chosen;
  //   3. listed order, so the first image is the default until the toms
  //      point elsewhere.
  // Images left blank on the finish are skipped; with none left, the
  // finish's default (full drum kit) image is used.
  function getKitImage() {

    const finish = getSelected(finishStep);

    if (!finish) {
      return '';
    }

    const fallback = finish.dataset.finishImage || '';
    const candidates = KIT_IMAGES[valueOf(getSelected(kitSizeStep))];

    if (!candidates) {
      return fallback;
    }

    let images = {};

    try {
      images = JSON.parse(finish.dataset.kitImages || '{}');
    } catch (error) {
      return fallback;
    }

    const counts = getTomCounts();

    const best = candidates
      .map(([field, up, down], index) => ({
        field,
        index,
        excess: Math.max(0, counts.up - up) + Math.max(0, counts.down - down),
        distance: Math.abs(counts.up - up) + Math.abs(counts.down - down)
      }))
      .sort((a, b) => a.excess - b.excess || a.distance - b.distance || a.index - b.index)
      .find(({ field }) => images[field]);

    return best ? images[best.field] : fallback;

  }


  // ==================================================
  // BADGE & INTERIOR STEP
  // ==================================================

  function createShellDependentStep(previous) {

    if (!shellDependentSource) {
      return;
    }

    const material = getShellMaterial();

    const group = function (type, label) {

      const options = (shellDependentRecords[type] || [])
        .filter((record) => record && matchesMaterial(record.material, material))
        .map((record) => {

          const name = record.name || record.value || label;

          return `
            <button
              type="button"
              class="kit-builder__option kit-builder__image-option kit-builder__shell-dependent-option"
              data-shell-dependent-option
              data-shell-dependent-type="${type}"
              data-value="${escapeHTML(record.value || name)}"
              data-option-name="${escapeHTML(name)}"
              data-shell-material="${escapeHTML(record.material || '')}"
              aria-pressed="false"
            >
              ${record.image ? `<img class="kit-builder__image-option-image" src="${escapeHTML(record.image)}" alt="${escapeHTML(name)}" loading="lazy">` : ''}
              <span class="kit-builder__image-option-name">${escapeHTML(name)}</span>
            </button>
          `;

        }).join('');

      return `
        <div class="kit-builder__shell-dependent-group" data-shell-dependent-group="${type}">
          <div class="kit-builder__component-selector-label">${label}</div>
          <div class="kit-builder__options kit-builder__shell-dependent-options" data-options>${options}</div>
        </div>
      `;

    };

    const step = document.createElement('div');

    step.className = 'kit-builder__step kit-builder__shell-dependent-step';
    step.setAttribute('data-shell-dependent-step', '');
    step.dataset.shellMaterial = material;

    step.innerHTML = `
      <div class="kit-builder__step-header">
        <div class="kit-builder__step-title">
          <span class="kit-builder__step-number"></span>
          <span class="kit-builder__step-label">Badge &amp; Interior</span>
        </div>
      </div>
      <div class="kit-builder__step-content">
        ${group('badge', 'Badge')}
        ${group('interior', 'Interior')}
        <div class="kit-builder__shell-dependent-status" data-shell-dependent-status aria-live="polite">
          Badge and interior are included with your kit.
        </div>
      </div>
    `;

    ['badge', 'interior'].forEach(function (type) {

      const match = previous[type] && $$(`[data-shell-dependent-type="${type}"]`, step)
        .find((option) => option.dataset.value === previous[type]);

      if (match) {
        markSelected(match, true);
      }

    });

    dynamicSteps.appendChild(step);

  }


  function updateShellDependentStatus(step) {

    ['badge', 'interior'].forEach(function (type) {

      const group = $(`[data-shell-dependent-group="${type}"]`, step);

      if (group) {
        group.classList.toggle('is-selected', Boolean(getShellDependent(step, type)));
      }

    });

  }


  // ==================================================
  // DYNAMIC STEPS
  // ==================================================

  function createDynamicSteps(components) {

    // Remember current choices, grouped by drum type, so they survive a
    // rebuild (e.g. a kit size change keeps Bass Drum 1, Tom 1, Tom 2…).
    const previousDrums = {};

    getDrumSteps().forEach(function (step) {

      const type = step.dataset.componentType;

      previousDrums[type] = previousDrums[type] || [];
      previousDrums[type].push({
        value: valueOf(getSelected(step)),
        accessories: getAccessoryValues(step)
      });

    });

    const previousDependentStep = getShellDependentStep();

    const previousShellDependent = {
      badge: previousDependentStep ? valueOf(getShellDependent(previousDependentStep, 'badge')) : '',
      interior: previousDependentStep ? valueOf(getShellDependent(previousDependentStep, 'interior')) : ''
    };

    dynamicSteps.innerHTML = '';

    if (!components || ![kitSizeStep, shellStep, finishStep].every(getSelected)) {
      numberSteps();
      refresh();
      return;
    }

    // Badge / interior comes before the drums; the snare (if added) goes last.
    createShellDependentStep(previousShellDependent);

    const allComponents = hasSnare ? components.concat([SNARE_COMPONENT]) : components;

    allComponents.forEach(function (component, index) {

      const template = $(`[data-component-template="${component.type}"]`);

      if (!template) {
        console.warn('Kit builder: no template found for', component.type);
        return;
      }

      const clone = template.content.cloneNode(true);
      const step = $('.kit-builder__step', clone);
      const label = $('.kit-builder__component-label', clone);

      if (label) {
        label.textContent = component.label;
      }

      if (step) {
        step.dataset.componentIndex = index;
        step.dataset.componentType = component.type;
      }

      dynamicSteps.appendChild(clone);

    });

    numberSteps();
    renderPrices();

    // Restore previous drum / lugs / mount choices that are still available,
    // matching each drum to the same-numbered drum of its type.
    const typeCounts = {};

    getDrumSteps().forEach(function (step) {

      const type = step.dataset.componentType;
      const position = typeCounts[type] || 0;
      const previous = (previousDrums[type] || [])[position];

      typeCounts[type] = position + 1;

      if (!previous) {
        return;
      }

      restoreChoice(step, MAIN_OPTION, previous.value);

      // The drum decides which lugs / mounts are available.
      filterAccessories(step);

      restoreAccessories(step, previous.accessories);

    });

    getDynamicSteps().forEach(updateStepState);

    refresh();

  }


  function restoreChoice(step, selector, value) {

    const match = value && $$(selector, step)
      .find((option) => option.dataset.value === value && !option.hidden);

    if (match) {
      selectInGroup(match);
    }

    return Boolean(match);

  }


  // ==================================================
  // SELECTION HANDLING
  // ==================================================

  function selectOption(step, option) {

    const isMainOption =
      !option.dataset.shellDependentType &&
      !option.hasAttribute('data-accessory-option');

    if (isMainOption && isSelected(option)) {
      return;
    }

    const wasComplete = isStepComplete(step);

    selectInGroup(option);

    if (step === kitSizeStep) {
      changeKitSize(option.dataset.value);
    } else if (step === shellStep) {
      changeShell();
    } else if (step === finishStep) {
      changeFinish();
    } else if (option.dataset.shellDependentType) {
      updateShellDependentStatus(step);
    } else if (isMainOption) {
      // A new drum size can change which lugs / mounts are allowed.
      filterAccessories(step);
    }

    updateStepState(step);
    refresh();

    // Only move on once everything in this step is complete. Kit size,
    // shell and finish always move on, as changing them can leave later
    // steps unfinished.
    if (isStepComplete(step) && (!wasComplete || step.hasAttribute('data-fixed-step'))) {
      showNextIncompleteStep(step);
    }

  }


  // Changing kit size keeps everything that still fits: shell, finish,
  // badge / interior, and any drums the new size still includes.
  function changeKitSize(value) {

    if (!KIT_SIZES[value]) {
      return;
    }

    currentComponents = buildComponents(value);

    shellStep.classList.add('is-available');

    if (getSelected(finishStep)) {
      createDynamicSteps(currentComponents);
    }

    numberSteps();

  }


  // Changing shell invalidates the finish, badge / interior and drums.
  function changeShell() {

    clearStep(finishStep);

    dynamicSteps.innerHTML = '';

    finishStep.hidden = false;
    finishStep.classList.add('is-available');

    renderFinishOptions();
    renderPrices();
    numberSteps();

  }


  function changeFinish() {
    createDynamicSteps(currentComponents);
  }


  // ==================================================
  // SELECTIONS
  // ==================================================

  function getSelections() {

    const material = getShellMaterial();
    const selections = [];

    [
      [kitSizeStep, 'Kit Size'],
      [shellStep, 'Shell'],
      [finishStep, 'Finish']
    ].forEach(function ([step, label]) {

      const option = getSelected(step);

      if (option) {
        selections.push({
          step,
          type: 'normal',
          label,
          value: getOptionText(option),
          cost: getPrice(option, material)
        });
      }

    });

    const dependentStep = getShellDependentStep();

    if (dependentStep) {

      [['badge', 'Badge'], ['interior', 'Interior']].forEach(function ([type, label]) {

        const option = getShellDependent(dependentStep, type);

        if (option) {
          selections.push({
            step: dependentStep,
            type,
            label,
            value: option.dataset.optionName || getOptionText(option),
            cost: 0
          });
        }

      });

    }

    getDrumSteps().forEach(function (step) {

      const drumLabel = getComponentLabel(step);
      const drum = getSelected(step);

      if (drum) {
        selections.push({
          step,
          type: 'drum',
          label: drumLabel,
          value: getOptionText(drum),
          cost: getPrice(drum, material)
        });
      }

      getAccessoryGroups(step).forEach(function ({ type, label }) {

        const option = getAccessory(step, type);

        if (option) {
          selections.push({
            step,
            type: 'accessory',
            accessoryType: type,
            label,
            parentLabel: drumLabel,
            value: getOptionText(option),
            cost: getPrice(option, material)
          });
        }

      });

    });

    return selections;

  }


  function isAccessorySelection(selection) {
    return selection.type === 'accessory';
  }


  function getTotal(selections) {
    return selections.reduce((total, selection) => total + selection.cost, 0);
  }


  function getDrumGroups(selections) {

    return selections
      .filter((selection) => selection.type === 'drum')
      .map((drum) => ({
        drum,
        accessories: selections.filter(
          (selection) => isAccessorySelection(selection) && selection.step === drum.step
        )
      }));

  }


  // ==================================================
  // SUMMARY
  // ==================================================

  const SUMMARY_ITEM_CLASSES = {
    drum: ' kit-builder__summary-drum-item',
    accessory: ' kit-builder__summary-accessory-item',
    badge: ' kit-builder__summary-shell-option-item',
    interior: ' kit-builder__summary-shell-option-item'
  };


  // The summary list is split into collapsible groups: "Kit" (kit size,
  // shell, finish, badge, interior) and one per drum (the drum plus its
  // options). Groups start folded; open ones stay open between updates.
  const openSummaryGroups = new Set();


  function getSummaryGroups(selections) {

    const groups = [];

    const kitItems = selections.filter((selection) => !selection.step.dataset.componentType);

    if (kitItems.length) {
      groups.push({
        key: 'kit',
        title: 'Kit',
        value: kitItems
          .filter((selection) => selection.type === 'normal')
          .map((selection) => selection.value)
          .join(' · '),
        items: kitItems
      });
    }

    getDrumSteps().forEach(function (step) {

      const items = selections.filter((selection) => selection.step === step);

      if (!items.length) {
        return;
      }

      const drum = items.find((selection) => selection.type === 'drum');

      groups.push({
        key: getComponentLabel(step),
        title: getComponentLabel(step),
        value: drum ? drum.value : 'Size not chosen yet',
        items
      });

    });

    return groups;

  }


  function renderSummary() {

    summarySelections = getSelections();

    if (!summarySelections.length) {
      summary.innerHTML = `
        <div class="kit-builder__summary-empty">
          <span>Your selections will appear here.</span>
          <strong>Scroll down to start building your dream kit.</strong>
          <p>Once you've finished selecting your kit, click: <strong>Send Configuration to Our Team</strong>.</p>
        </div>
      `;
      return;
    }

    const finish = getSelected(finishStep);
    const imageURL = getKitImage();

    const imageHTML = imageURL
      ? `
        <div class="kit-builder__summary-image">
          <img src="${escapeHTML(imageURL)}" alt="${escapeHTML(getOptionText(finish))}">
          <p class="kit-builder__summary-image-note">Note: Images are for illustration purposes only</p>
        </div>
      `
      : `
        <div class="kit-builder__summary-image--empty">
          <span>Your Ludwig kit preview will appear here once you choose a finish.</span>
        </div>
      `;

    const itemHTML = (selection) => `
      <div
        class="kit-builder__summary-item${SUMMARY_ITEM_CLASSES[selection.type] || ''}"
        data-selection-type="${selection.type}"
      >
        <div class="kit-builder__summary-item-text">
          <span class="kit-builder__summary-label">${escapeHTML(selection.label)}</span>
          <div class="kit-builder__summary-value-row">
            <span class="kit-builder__summary-value">${escapeHTML(selection.value)}</span>
            <span class="kit-builder__summary-cost">${formatCost(selection.cost)}</span>
          </div>
        </div>

        <button
          type="button"
          class="kit-builder__summary-edit"
          data-edit-index="${summarySelections.indexOf(selection)}"
          aria-label="Edit ${escapeHTML(selection.label)}"
          title="Edit ${escapeHTML(selection.label)}"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5z"></path>
            <path d="M14 6l4 4"></path>
          </svg>
        </button>
      </div>
    `;

    const itemsHTML = getSummaryGroups(summarySelections).map(function (group) {

      const open = openSummaryGroups.has(group.key);

      return `
        <div class="kit-builder__summary-group${open ? ' is-open' : ''}">
          <button
            type="button"
            class="kit-builder__summary-group-toggle"
            data-summary-toggle="${escapeHTML(group.key)}"
            aria-expanded="${open}"
          >
            <span class="kit-builder__summary-group-copy">
              <span class="kit-builder__summary-label">${escapeHTML(group.title)}</span>
              <span class="kit-builder__summary-group-value">${escapeHTML(group.value)}</span>
            </span>
            <span class="kit-builder__summary-group-cost">${formatCost(getTotal(group.items))}</span>
            <span class="kit-builder__summary-chevron" aria-hidden="true"></span>
          </button>
          <div class="kit-builder__summary-group-items"${open ? '' : ' hidden'}>
            ${group.items.map(itemHTML).join('')}
          </div>
        </div>
      `;

    }).join('');

    const snareHTML = canAddSnare()
      ? `
        <div class="kit-builder__summary-snare">
          ${hasSnare
            ? '<button type="button" class="kit-builder__snare-button kit-builder__snare-button--remove" data-remove-snare>Remove snare</button>'
            : '<button type="button" class="kit-builder__snare-button" data-add-snare><span aria-hidden="true">+</span> Add a snare?</button>'}
        </div>
      `
      : '';

    summary.innerHTML = `
      ${imageHTML}

      <div class="kit-builder__summary-selections">${itemsHTML}</div>

      ${snareHTML}

      <div class="kit-builder__summary-total">
        <div class="kit-builder__summary-total-copy">
          <span class="kit-builder__summary-total-label">Your Estimated Total</span>
          <span class="kit-builder__summary-total-note">Based on your current configuration</span>
        </div>
        <span class="kit-builder__summary-total-price">${formatPrice(getTotal(summarySelections))}</span>
      </div>
    `;

  }


  function updateRequestButton() {

    if (!requestButton) {
      return;
    }

    const complete = isConfigurationComplete();

    requestButton.disabled = !complete;
    requestButton.setAttribute('aria-disabled', String(!complete));
    requestButton.classList.toggle('is-ready', complete);

  }


  // The line under Send: how many sections are left to complete, with a
  // button that jumps to the first one.
  function updateProgress() {

    if (!progress) {
      return;
    }

    const text = $('[data-progress-text]', progress);
    const jump = $('[data-progress-jump]', progress);
    const incomplete = getSteps().filter((step) => !step.hidden && !isStepComplete(step));
    const next = incomplete[0];
    const complete = isConfigurationComplete();

    progress.classList.toggle('is-complete', complete);

    if (complete) {
      text.textContent = 'All sections complete – ready to send';
    } else if (!summarySelections.length) {
      text.textContent = 'Start by choosing your kit size';
    } else if (!getDrumSteps().length) {
      // The drum sections only exist once a finish is chosen, so a count
      // here would be too low.
      text.textContent = 'Keep going – your drums appear once you choose a finish';
    } else {
      const count = incomplete.length;
      text.innerHTML = `<strong>${count}</strong> ${count === 1 ? 'section' : 'sections'} left to complete`;
    }

    jump.hidden = complete || !next;

    if (next) {
      jump.textContent = `Go to ${getStepLabel(next)}`;
      jump.onclick = () => showStep(next);
    }

  }


  function getStepLabel(step) {
    const label = $('.kit-builder__step-label, .kit-builder__component-label', step);
    return label ? label.textContent.trim() : 'next step';
  }


  function refresh() {

    renderSummary();
    renderMiniSummary();
    updateRequestButton();
    updateSnareActions();
    updateProgress();
    saveProgress();

    if (restartButton) {
      restartButton.disabled = !summarySelections.length;
    }

  }


  // ==================================================
  // SAVED PROGRESS (localStorage)
  //
  // Selections are saved after every change so going back (or
  // refreshing) doesn't lose the kit. Prices aren't saved; they're
  // recalculated on restore. Cleared after a successful send, on
  // "Start again", or once older than STORAGE_MAX_AGE.
  // ==================================================

  const STORAGE_KEY = 'ludwigKitBuilder:v1';
  const STORAGE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

  let isRestoring = false;

  // Set when the form is sent; stops the kit being saved again while the
  // page is leaving.
  let sentThisVisit = false;

  // One-time note left when Send is pressed. The thank-you only shows when
  // Shopify confirms the send AND this note exists; it's removed straight
  // away, so refreshing the confirmation page doesn't show it again.
  const SENT_KEY = 'ludwigKitBuilder:justSent';
  const SENT_MAX_AGE = 60 * 60 * 1000;


  function saveProgress() {

    if (isRestoring || sentThisVisit) {
      return;
    }

    try {

      if (!summarySelections.length) {
        localStorage.removeItem(STORAGE_KEY);
        return;
      }

      const dependentStep = getShellDependentStep();

      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        savedAt: Date.now(),
        kitSize: valueOf(getSelected(kitSizeStep)),
        shell: valueOf(getSelected(shellStep)),
        finish: valueOf(getSelected(finishStep)),
        badge: dependentStep ? valueOf(getShellDependent(dependentStep, 'badge')) : '',
        interior: dependentStep ? valueOf(getShellDependent(dependentStep, 'interior')) : '',
        snare: hasSnare,
        drums: getDrumSteps().map((step) => ({
          value: valueOf(getSelected(step)),
          accessories: getAccessoryValues(step)
        }))
      }));

    } catch (error) {
      // Storage unavailable (private browsing, blocked, full): carry on without it.
    }

  }


  function markJustSent() {

    try {
      localStorage.setItem(SENT_KEY, String(Date.now()));
    } catch (error) {
      // Storage unavailable.
    }

  }


  // true: Send was pressed recently (note removed); false: it wasn't;
  // null: storage unavailable, so we can't tell.
  function takeJustSent() {

    try {
      const sentAt = Number(localStorage.getItem(SENT_KEY));
      localStorage.removeItem(SENT_KEY);
      return Boolean(sentAt) && Date.now() - sentAt < SENT_MAX_AGE;
    } catch (error) {
      return null;
    }

  }


  function clearSavedProgress() {

    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage unavailable.
    }

  }


  function loadSavedProgress() {

    try {

      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');

      if (!saved || !saved.savedAt || Date.now() - saved.savedAt > STORAGE_MAX_AGE) {
        clearSavedProgress();
        return null;
      }

      return saved;

    } catch (error) {
      clearSavedProgress();
      return null;
    }

  }


  // Replays the saved choices in order: kit size, shell, finish, then
  // badge / interior and each drum. Options that no longer exist (e.g.
  // removed from the store) are skipped.
  function restoreProgress(saved) {

    isRestoring = true;
    hasSnare = Boolean(saved.snare);

    try {

      if (restoreChoice(kitSizeStep, MAIN_OPTION, saved.kitSize)) {
        changeKitSize(saved.kitSize);
      }

      if (restoreChoice(shellStep, MAIN_OPTION, saved.shell)) {
        changeShell();

        if (restoreChoice(finishStep, MAIN_OPTION, saved.finish)) {
          changeFinish();
        }
      }

      const dependentStep = getShellDependentStep();

      if (dependentStep) {
        restoreChoice(dependentStep, '[data-shell-dependent-type="badge"]', saved.badge);
        restoreChoice(dependentStep, '[data-shell-dependent-type="interior"]', saved.interior);
        updateShellDependentStatus(dependentStep);
      }

      getDrumSteps().forEach(function (step, index) {

        const drum = (saved.drums || [])[index];

        if (!drum) {
          return;
        }

        restoreChoice(step, MAIN_OPTION, drum.value);
        filterAccessories(step);

        // Saves from before the extra options only had lugs and mount.
        restoreAccessories(step, drum.accessories || { lugs: drum.lugs, mount: drum.mount });

      });

      getSteps().forEach(updateStepState);

    } finally {
      isRestoring = false;
    }

    refresh();

  }


  // ==================================================
  // MINI SUMMARY (image + total while scrolling)
  // ==================================================

  // Show the mini summary once less than this much of the Your Kit panel
  // is left on screen.
  const MINI_SUMMARY_OFFSET = 120;

  let miniSummaryFrame = null;


  function renderMiniSummary() {

    if (!miniSummary) {
      return;
    }

    $('[data-mini-summary-price]', miniSummary).textContent =
      formatPrice(getTotal(summarySelections));

    const finish = getSelected(finishStep);
    const imageURL = getKitImage();
    const imageWrapper = $('[data-mini-summary-image]', miniSummary);
    const image = $('[data-mini-summary-img]', miniSummary);

    imageWrapper.hidden = !imageURL;

    if (imageURL && image.getAttribute('src') !== imageURL) {
      image.src = imageURL;
      image.alt = getOptionText(finish);
    }

    updateMiniSummaryVisibility();

  }


  // Visible while the Your Kit panel is scrolled off the top of the screen
  // and the customer is still within the builder steps.
  function updateMiniSummaryVisibility() {

    miniSummaryFrame = null;

    if (!miniSummary || !yourKit || !builderSteps) {
      return;
    }

    const summaryGone = yourKit.getBoundingClientRect().bottom < MINI_SUMMARY_OFFSET;
    const inBuilder = builderSteps.getBoundingClientRect().bottom > MINI_SUMMARY_OFFSET;
    const visible = summarySelections.length > 0 && summaryGone && inBuilder;

    if (visible === miniSummary.classList.contains('is-visible')) {
      return;
    }

    miniSummary.classList.toggle('is-visible', visible);
    miniSummary.setAttribute('aria-hidden', String(!visible));
    $('[data-mini-summary-view]', miniSummary).tabIndex = visible ? 0 : -1;

  }


  function scheduleMiniSummaryUpdate() {

    if (miniSummaryFrame === null) {
      miniSummaryFrame = requestAnimationFrame(updateMiniSummaryVisibility);
    }

  }


  // ==================================================
  // SNARE (optional)
  // ==================================================

  function getSnareStep() {
    return $('[data-component-type="snare"]', dynamicSteps);
  }


  // The snare can be added once the drums exist (kit size, shell and finish chosen).
  function canAddSnare() {
    return getDrumSteps().some((step) => step.dataset.componentType !== 'snare');
  }


  function updateSnareActions() {

    if (!snareActions) {
      return;
    }

    // Once added, the snare step has its own "Remove snare" button.
    snareActions.hidden = !canAddSnare() || hasSnare;

  }


  function addSnare() {

    if (hasSnare || !canAddSnare()) {
      return;
    }

    hasSnare = true;

    // Rebuilding keeps every other drum's choices.
    createDynamicSteps(currentComponents);

    showStep(getSnareStep());

  }


  function openRemoveSnareModal() {

    if (snareModal) {
      openModal(snareModal);
    } else {
      removeSnare();
    }

  }


  function removeSnare() {

    const step = getSnareStep();
    const wasCurrent = Boolean(step && step.classList.contains('is-current'));

    hasSnare = false;

    if (step) {
      step.remove();
    }

    numberSteps();
    refresh();

    if (wasCurrent) {
      const firstIncomplete = getSteps().find((item) => !item.hidden && !isStepComplete(item));

      if (firstIncomplete) {
        showStep(firstIncomplete, false);
      }
    }

  }


  // ==================================================
  // RESTART
  // ==================================================

  // Asks for confirmation first; restart() runs from the modal's confirm button.
  function openRestartModal() {

    if (restartModal) {
      openModal(restartModal);
    } else {
      restart();
    }

  }


  function restart() {

    currentComponents = null;
    hasSnare = false;
    openSummaryGroups.clear();

    [kitSizeStep, shellStep, finishStep].forEach(clearStep);

    shellStep.classList.remove('is-available');
    finishStep.classList.remove('is-available');
    finishStep.hidden = true;

    finishOptions.innerHTML = '';
    finishOptions.hidden = true;

    dynamicSteps.innerHTML = '';

    numberSteps();
    renderPrices();
    refresh();
    showStep(kitSizeStep);

  }


  // ==================================================
  // REQUEST FORM
  // ==================================================

  function buildConfigurationText(selections) {

    const lines = [
      'LUDWIG KIT CONFIGURATION',
      '========================',
      ''
    ];

    selections.forEach(function (selection) {

      if (selection.type === 'normal') {
        lines.push(`${selection.label}: ${selection.value} — ${formatCost(selection.cost)}`);
      }

    });

    selections.forEach(function (selection) {

      if (selection.type === 'badge' || selection.type === 'interior') {
        lines.push(`${selection.label}: ${selection.value} — ${formatCost(selection.cost)}`);
      }

    });

    lines.push('');

    getDrumGroups(selections).forEach(function ({ drum, accessories }) {

      lines.push(`${drum.label}: ${drum.value} — ${formatCost(drum.cost)}`);

      accessories.forEach(function (accessory) {
        lines.push(`  ${drum.label} ${accessory.label}: ${accessory.value} — ${formatCost(accessory.cost)}`);
      });

      lines.push('');

    });

    lines.push(`YOUR ESTIMATED TOTAL: ${formatPrice(getTotal(selections))}`);

    return lines.join('\n');

  }


  function buildModalConfigurationHTML(selections) {

    const standardRows = selections
      .filter((selection) => selection.type !== 'drum' && !isAccessorySelection(selection))
      .map((selection) => `
        <div class="kit-builder__modal-row">
          <span class="kit-builder__modal-row-label">${escapeHTML(selection.label)}</span>
          <span class="kit-builder__modal-row-value">${escapeHTML(selection.value)}</span>
          <span class="kit-builder__modal-row-price">${formatCost(selection.cost)}</span>
        </div>
      `).join('');

    const drumGroups = getDrumGroups(selections).map(function ({ drum, accessories }) {

      const accessoryRows = accessories.map((accessory) => `
        <div class="kit-builder__modal-child-row">
          <span class="kit-builder__modal-child-label">${escapeHTML(accessory.label)}</span>
          <span class="kit-builder__modal-child-value">${escapeHTML(accessory.value)}</span>
          <span class="kit-builder__modal-child-price">${formatCost(accessory.cost)}</span>
        </div>
      `).join('');

      return `
        <div class="kit-builder__modal-drum-group">
          <div class="kit-builder__modal-drum-row">
            <div class="kit-builder__modal-drum-copy">
              <span class="kit-builder__modal-drum-label">${escapeHTML(drum.label)}</span>
              <span class="kit-builder__modal-drum-value">${escapeHTML(drum.value)}</span>
            </div>
            <span class="kit-builder__modal-drum-price">${formatCost(drum.cost)}</span>
          </div>
          ${accessoryRows ? `<div class="kit-builder__modal-children">${accessoryRows}</div>` : ''}
        </div>
      `;

    }).join('');

    return `
      <div class="kit-builder__modal-configuration" data-modal-configuration>

        <div class="kit-builder__modal-configuration-header">
          <span>Your Configuration</span>
        </div>

        ${standardRows ? `
          <div class="kit-builder__modal-section">
            <div class="kit-builder__modal-section-title">Kit</div>
            <div class="kit-builder__modal-rows">${standardRows}</div>
          </div>
        ` : ''}

        ${drumGroups ? `
          <div class="kit-builder__modal-section kit-builder__modal-drums-section">
            <div class="kit-builder__modal-section-title">Drums</div>
            <div class="kit-builder__modal-drums">${drumGroups}</div>
          </div>
        ` : ''}

        <div class="kit-builder__modal-total">
          <div class="kit-builder__modal-total-copy">
            <span>Your Estimated Total</span>
            <small>Based on your current configuration</small>
          </div>
          <strong>${formatPrice(getTotal(selections))}</strong>
        </div>

      </div>
    `;

  }


  function renderModalConfiguration(selections) {

    if (!requestDialog) {
      return;
    }

    const existing = $('[data-modal-configuration]', requestDialog);

    if (existing) {
      existing.remove();
    }

    const formInner = $('.kit-builder__request-form-inner', requestDialog);

    if (!formInner || !selections.length) {
      return;
    }

    const heading = $('h3', formInner);
    const html = buildModalConfigurationHTML(selections);

    if (heading) {
      heading.insertAdjacentHTML('afterend', html);
    } else {
      formInner.insertAdjacentHTML('afterbegin', html);
    }

  }


  // The configuration goes in the (read-only) message box only, so it
  // appears once in the email.
  function populateRequestForm(selections) {

    const message = $('[data-kit-builder-message]');

    if (message) {
      message.value = buildConfigurationText(selections);
    }

  }


  // ==================================================
  // MODALS (request form, restart confirmation)
  // ==================================================

  function openModal(modal) {

    lastFocusedElement = document.activeElement;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kit-builder-modal-open');

    requestAnimationFrame(() => modal.classList.add('is-open'));

    const focusTarget =
      $('[data-autofocus]', modal) ||
      $('.kit-builder__request-close', modal);

    if (focusTarget) {
      setTimeout(() => focusTarget.focus(), 50);
    }

  }


  function closeModal(modal) {

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kit-builder-modal-open');

    setTimeout(function () {

      if (!modal.classList.contains('is-open')) {
        modal.hidden = true;
      }

    }, 250);

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }

  }


  function openRequestModal() {

    if (!requestModal || !isConfigurationComplete()) {
      return;
    }

    const selections = getSelections();

    populateRequestForm(selections);
    renderModalConfiguration(selections);
    openModal(requestModal);

  }


  // ==================================================
  // SENDING THE REQUEST
  //
  // The contact form submits normally and the page redirects with
  // Shopify's confirmation. Right before it submits, the configuration
  // fields (including the read-only message box) are refreshed from
  // what's on screen so the email always matches the kit, and the saved
  // kit is cleared.
  // ==================================================

  function onRequestSubmit() {

    populateRequestForm(getSelections());

    sentThisVisit = true;
    markJustSent();
    clearSavedProgress();

  }


  // Shopify's spam protection can take over the submit and skip submit
  // listeners, so the Send click also leaves the "just sent" note (only
  // when the form is valid). It doesn't change the button, so the
  // browser still submits the form normally.
  function onSendClick() {

    if (requestForm.checkValidity()) {
      markJustSent();
    }

  }


  // Removes ?contact_posted=true (and the #contact_form jump) from the
  // address without reloading the page.
  function clearSentMarker() {

    try {

      const url = new URL(window.location.href);

      url.searchParams.delete('contact_posted');

      if (url.hash === '#contact_form' || (requestForm && url.hash === `#${requestForm.id}`)) {
        url.hash = '';
      }

      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);

    } catch (error) {
      // Older browsers: the pop-up may show again on refresh.
    }

  }


  function trapFocus(event) {

    if (event.key !== 'Tab') {
      return;
    }

    const focusable = $$(
      'button:not([disabled]), input:not([disabled]), textarea:not([disabled]), ' +
      'select:not([disabled]), [href], [tabindex]:not([tabindex="-1"])',
      event.currentTarget
    ).filter((element) => !element.hidden && element.offsetParent !== null);

    if (!focusable.length) {
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }

  }


  // ==================================================
  // EVENTS
  // ==================================================

  // One delegated listener handles every option, including steps
  // that are created later.
  builder.addEventListener('click', function (event) {

    const option = event.target.closest('[data-options] [data-value]');
    const step = option && option.closest('.kit-builder__step');

    if (!step || option.hidden || !option.dataset.value) {
      return;
    }

    event.preventDefault();
    selectOption(step, option);

  });


  // Arrow keys move focus within an option group.
  builder.addEventListener('keydown', function (event) {

    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
      return;
    }

    const option = event.target.closest('[data-options] [data-value]');

    if (!option || !option.closest('.kit-builder__step')) {
      return;
    }

    const visible = getGroup(option).filter((item) => !item.hidden);
    const index = visible.indexOf(option);

    const next = event.key === 'ArrowRight'
      ? visible[Math.min(index + 1, visible.length - 1)]
      : visible[Math.max(index - 1, 0)];

    if (next && next !== option) {
      event.preventDefault();
      next.focus();
    }

  });


  summary.addEventListener('click', function (event) {

    const toggle = event.target.closest('[data-summary-toggle]');

    if (toggle) {

      const key = toggle.dataset.summaryToggle;
      const open = !openSummaryGroups.has(key);
      const group = toggle.closest('.kit-builder__summary-group');

      if (open) {
        openSummaryGroups.add(key);
      } else {
        openSummaryGroups.delete(key);
      }

      group.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      $('.kit-builder__summary-group-items', group).hidden = !open;

      return;

    }

    const button = event.target.closest('[data-edit-index]');
    const selection = button && summarySelections[button.dataset.editIndex];

    if (selection) {
      showStep(selection.step);
    }

  });


  // Smooth scroll so the element sits at the top of the screen, just
  // below the theme's sticky header (if it has one). The position is
  // checked again once scrolling stops, as the page can shift on the way
  // (e.g. images loading), and corrected if it's off.
  const SCROLL_GAP = 16;

  function getHeaderOffset() {

    let offset = 0;

    document.querySelectorAll('header, sticky-header, [class*="header"]').forEach(function (element) {

      if (builder.contains(element)) {
        return;
      }

      const position = window.getComputedStyle(element).position;

      if (position !== 'fixed' && position !== 'sticky') {
        return;
      }

      const rect = element.getBoundingClientRect();

      // Only headers pinned to the top of the screen count.
      if (rect.top <= 1 && rect.bottom > 0 && rect.height < window.innerHeight / 2) {
        offset = Math.max(offset, rect.bottom);
      }

    });

    return offset;

  }


  function getScrollTarget(element) {
    return element.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - SCROLL_GAP;
  }


  function scrollToElement(element) {

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'auto' : 'smooth';

    window.scrollTo({ top: getScrollTarget(element), behavior });

    let timer = null;

    const check = function () {

      window.removeEventListener('scroll', wait);

      if (Math.abs(getScrollTarget(element) - window.scrollY) > 4) {
        window.scrollTo({ top: getScrollTarget(element), behavior });
      }

    };

    const wait = function () {
      clearTimeout(timer);
      timer = setTimeout(check, 150);
    };

    window.addEventListener('scroll', wait, { passive: true });
    wait();

  }


  // Banner / How it works buttons: smooth scroll to Your Kit, or to the
  // how-to: the section with the ID set in the editor, else the How it
  // works strip, else the section directly below the kit builder.
  function getHowToSection(link) {

    const id = link.dataset.howToId;
    const byId = id && document.getElementById(id);

    if (byId) {
      return byId;
    }

    const strip = $('[data-how-to]');

    if (strip) {
      return strip;
    }

    const section = builder.closest('.shopify-section') || builder;
    return section.nextElementSibling;

  }


  builder.addEventListener('click', function (event) {

    const link = event.target.closest('[data-banner-jump]');

    if (!link) {
      return;
    }

    const target = link.dataset.bannerJump === 'summary' ? yourKit : getHowToSection(link);

    if (target) {
      event.preventDefault();
      scrollToElement(target);
    }

  });


  if (miniSummary && yourKit) {

    window.addEventListener('scroll', scheduleMiniSummaryUpdate, { passive: true });
    window.addEventListener('resize', scheduleMiniSummaryUpdate);

    $('[data-mini-summary-view]', miniSummary).addEventListener('click', function () {
      scrollToElement(yourKit);
    });

  }


  // "Add a snare?" / "Remove snare" buttons (under the steps and in the summary).
  builder.addEventListener('click', function (event) {

    if (event.target.closest('[data-add-snare]')) {
      addSnare();
    } else if (event.target.closest('[data-remove-snare]')) {
      openRemoveSnareModal();
    }

  });


  if (snareModal) {

    const confirmRemove = $('[data-confirm-remove-snare]', snareModal);

    if (confirmRemove) {
      confirmRemove.addEventListener('click', function () {
        closeModal(snareModal);
        removeSnare();
      });
    }

  }


  if (restartButton) {
    restartButton.addEventListener('click', openRestartModal);
  }


  if (requestButton) {
    requestButton.addEventListener('click', openRequestModal);
  }


  if (requestForm) {

    requestForm.addEventListener('submit', onRequestSubmit);

    const sendButton = $('[type="submit"]', requestForm);

    if (sendButton) {
      sendButton.addEventListener('click', onSendClick);
    }

  }


  // Coming back with the browser's Back button shows the kit as it was;
  // carry on saving changes to it.
  window.addEventListener('pageshow', function (event) {

    if (event.persisted && sentThisVisit) {
      sentThisVisit = false;
    }

  });


  if (thanksModal) {

    const buildAgain = $('[data-thanks-build-again]', thanksModal);

    if (buildAgain) {
      buildAgain.addEventListener('click', function () {
        closeModal(thanksModal);
        restart();
      });
    }

  }


  MODALS.forEach(function (modal) {

    $$('[data-close-modal]', modal).forEach(function (element) {
      element.addEventListener('click', () => closeModal(modal));
    });

    const dialog = $('.kit-builder__request-dialog', modal);

    if (dialog) {
      dialog.addEventListener('keydown', trapFocus);
    }

  });


  if (restartModal) {

    const confirmButton = $('[data-confirm-restart]', restartModal);

    if (confirmButton) {
      confirmButton.addEventListener('click', function () {
        closeModal(restartModal);
        restart();
      });
    }

  }


  document.addEventListener('keydown', function (event) {

    if (event.key !== 'Escape') {
      return;
    }

    MODALS.forEach(function (modal) {

      if (!modal.hidden) {
        closeModal(modal);
      }

    });

  });


  // ==================================================
  // INITIALISE
  // ==================================================

  renderKitSizeOptions();

  finishOptions.hidden = true;
  finishStep.hidden = true;

  numberSteps();
  renderPrices();

  // Shopify confirms a send by redirecting with ?contact_posted=true and
  // rendering the success marker. That stays in the address on refresh,
  // so it only counts as "just sent" alongside the one-time note left by
  // Send (or, without storage, on its own).
  const confirmedOnLoad =
    Boolean($('[data-form-success]')) ||
    /[?&]contact_posted=true(&|$)/.test(window.location.search);
  const justSent = takeJustSent();
  const sentOnLoad = confirmedOnLoad && justSent !== false;
  const sendErrorsOnLoad = Boolean(requestForm && $('.kit-builder__form-errors', requestForm));

  // Just sent: start fresh and say thank you. Otherwise (including a
  // refresh after sending) pick up any saved kit.
  const savedProgress = sentOnLoad ? null : loadSavedProgress();

  if (sentOnLoad && thanksModal) {
    openModal(thanksModal);
  }

  if (confirmedOnLoad) {
    clearSentMarker();
  }

  if (savedProgress) {

    restoreProgress(savedProgress);

    const firstIncomplete = getSteps().find((step) => !step.hidden && !isStepComplete(step));

    if (firstIncomplete) {
      showStep(firstIncomplete, false);
    }

  } else {

    clearSavedProgress();
    showStep(kitSizeStep, false);

  }

  refresh();

  // Shopify rejected the send (e.g. a missing field): reopen the request
  // pop-up with the restored kit so the customer can see the error.
  if (sendErrorsOnLoad && isConfigurationComplete()) {
    openRequestModal();
  }

});
